import React, { useState } from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { GetServerSidePropsContext } from 'next';
import { Container, Wrapper, Contacts, ContactItem, Informations, EmailItem } from '@pages/contact/styles';

import ContactForm from '@components/ContactForm';
import SuccessSubmission from '@components/SuccessSubmission';

function ContactPage() {
  const { t } = useTranslation('contact');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const onSuccess = () => {
    setShowConfirmation(true);
  };

  const onConfirmClick = () => {
    setShowConfirmation(false);
  };

  return (
    <Container className="contact-page">
      <Head>
        <title>{t('page-title')}</title>
        <meta property="og:title" content="Contact us" />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:secure_url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="279" />
        <meta property="og:description" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/kontakt`} />
      </Head>
      <Wrapper>
        {showConfirmation ? (
          <SuccessSubmission
            confirmClick={onConfirmClick}
            message={t('Message has been sent. We will response as soon as possible')}
          />
        ) : (
          <ContactForm onSuccessCallback={onSuccess} />
        )}

        <Informations>
          <Contacts>
            <ContactItem>
              Biuro Rozwoju Gospodarczego i Współpracy
              <br /> Międzynarodowej
            </ContactItem>
            <ContactItem>Departament Planowania i Rozwoju Gospodarczego</ContactItem>
            <ContactItem>Urząd Miasta Łodzi</ContactItem>
          </Contacts>
          <Contacts>
            <ContactItem>ul. Piotrkowska 104a</ContactItem>
            <ContactItem>90-926 Łódź</ContactItem>
            <ContactItem>tel. 042 638 59 39, 042 638 55 48</ContactItem>
            <EmailItem href="mailto:praktyki@praktyki.lodz.pl">e-mail: praktyki@praktyki.lodz.pl</EmailItem>
            <EmailItem href="mailto:boi@uml.lodz.pl">boi@uml.lodz.pl</EmailItem>
          </Contacts>
        </Informations>
      </Wrapper>
    </Container>
  );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  try {
    return {
      props: {
        ...(await serverSideTranslations(locale, [
          'homepage',
          'navbar',
          'footer',
          'offers',
          'candidate',
          'newsletter',
          'contact',
          'register',
        ])),
      },
    };
  } catch (error) {
    return { props: {} };
  }
}
export default ContactPage;
